// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"e_Oi","wrapperDark":"e_Pi","wrapperLight":"e_Qi"};